import React from 'react';

import {
  usegetUserRoleDetailsSubscription,
  UserRoleDetailsFragment,
} from '../../../graphql/hasura/generated';
import createDetailsLayout from '../../../layouts/createDetailsLayout';
import * as actions from '../actions';
import { UserRoleDetailsBody } from '../components/UserRoleDetailsBody';
import { UserRoleDetailsFooter } from '../components/UserRoleDetailsFooter';
import model from '../model';

const UserRoleDetailsLayout = createDetailsLayout<UserRoleDetailsFragment>();

export const UserRoleDetailsPage: React.FC<any> = () => {
  return (
    <UserRoleDetailsLayout
      modelName='UserRole'
      useQuery={(userRoleId) => {
        return usegetUserRoleDetailsSubscription({
          variables: { userRoleId },
        });
      }}
      actions={[
        model.actions.editAction,
        model.actions.deleteAction,
        actions.revokeAction,
      ]}
      body={(userRole) => <UserRoleDetailsBody userRole={userRole} />}
      footer={(userRole) => <UserRoleDetailsFooter userRole={userRole} />}
    />
  );
};
